<template>
  <el-container>
    <!-- 标题 -->
    <el-header class="pa-0">
      <div class="bg-color-w ht-62 dy-flex jy-c-sb">
        <div :xs="4" class="pl-30 dy-flex jy-c-sb align-i-c">
          <img src="/img/images/dbsx_icon.png" class="wt-40 ht-40" />
          <div class="pl-10 fs-20">{{ $t("grxx.logisticstracking") }}</div>
        </div>
        <!-- 中英文切换 -->
        <Languageqh v-if="$store.state.sysCs.sfqy_zywqh == '1'"></Languageqh>
      </div>
    </el-header>
    <!-- 内容 -->
    <el-main>
      <el-row class=" bg-color-w pt-30 pb-40 pl-50 pr-50" :style="wldjStyle">
        <div class="mt-15 dy-flex">
          <div class="pt-5 dy-flex">
            <div class="pt-3">{{ $t("xmsq.lsh") }}：</div>
            <div>
              <el-input v-model="lsh" size="mini"> </el-input>
            </div>
          </div>
          <div class="pt-10 dy-flex ml-10">
            <div>
              <span style="float: right;">{{ $t("common.rqfw") }}：</span>
            </div>
            <div class="pt-3">
              <el-radio-group v-model="day">
                <el-radio :label="-7">{{ $t("common.jyz") }}</el-radio>
                <el-radio :label="-30">{{ $t("common.jyy") }}</el-radio>
                <el-radio :label="-90">{{ $t("common.jsy") }}</el-radio>
                <el-radio :label="-365">{{ $t("common.jyn") }}</el-radio>
                <el-radio :label="-0">{{ $t("common.all") }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="dy-flex ml-10">
            <div>
              <el-button
                type="primary"
                icon="el-icon-edit-outline"
                class="fs-14 pa-10"
                size="medium"
                @click="getWlList()"
                >{{ $t("common.searchBtn") }}</el-button
              >
              <el-button
                icon="el-icon-refresh-right"
                class="fs-14 pa-10"
                size="medium"
                @click="clear()"
                >{{ $t("common.empty") }}</el-button
              >
            </div>
          </div>
        </div>
        <el-row class="mt-30 mb-40">
          <el-col>
            <!-- 表格上边描述 -->
            <el-row type="flex" justify="space-between">
              <el-col class="color-r">{{ radioName }}</el-col>
              <el-col class="text-a-r"
                >{{ $t("common.altogether") }} {{ wldjData.length
                }}{{ $t("common.bill") }}</el-col
              >
            </el-row>
            <!-- 表格表头 -->
            <el-row
              type="flex"
              justify="space-between"
              class="text-a-c bw-1 br-color-4g br-solid bg-color-1g mt-5"
            >
              <el-col class="br-r-1 br-color-4g br-r-solid py-10 fs-16">{{
                $t("common.djxx")
              }}</el-col>
              <el-col class="br-r-1 br-color-4g br-r-solid py-10 fs-16">{{
                $t("common.czy")
              }}</el-col>
              <el-col class="br-r-1 br-color-4g br-r-solid py-10 fs-16">{{
                $t("common.jebmxm")
              }}</el-col>
              <el-col class="fs-16 py-10">{{ $t("common.operation") }}</el-col>
            </el-row>
            <!-- 表格数据 -->
            <div
              class="overf-y-a"
              v-if="wldjData.length > 0"
              :style="wlsjStyle"
            >
              <template v-for="(item, index) in wldjData">
                <el-row :key="index">
                  <el-row
                    class="bw-1 br-color-4g br-solid bg-color-1g mt-20 pa-10"
                  >
                    <span>{{ item.clsj }}</span>
                    <span class="ml-20"
                      >{{ $t("common.bz") }}：{{ item.bz }}</span
                    >
                  </el-row>
                  <el-row
                    type="flex"
                    justify="space-between"
                    class="text-a-c bw-1 br-color-4g br-solid"
                  >
                    <el-col class="br-r-1 br-color-4g br-r-solid py-10 fs-16">
                      <p class="pt-10 pb-5 fw-7 color-8g">{{ item.model }}</p>
                      <p class="color-8g">{{ item.lsh }}</p>
                    </el-col>
                    <el-col class="br-r-1 br-color-4g br-r-solid py-10 fs-16">
                      <p class="pb-5"></p>
                      <p class="pt-10 color-g">{{ item.clr }}</p>
                    </el-col>
                    <el-col class="br-r-1 br-color-4g br-r-solid py-10 fs-16">
                      <p class="pt-10 pb-5 color-g">
                        {{ $t("common.ze") }}￥{{ item.je }}
                      </p>
                      <p class="color-g">{{ item.bmbh }}/{{ item.xmbh }}</p>
                    </el-col>
                    <el-col class="fs-16 py-10">
                      <p class="pt-10 color-g">
                        <el-tag
                          :type="
                            item.clzt == '已提交'
                              ? 'success'
                              : item.clzt == '未提交'
                              ? 'info'
                              : item.clzt == '保存未提交'
                              ? 'warning'
                              : item.clzt == '制单成功'
                              ? ''
                              : 'danger'
                          "
                          >{{ item.clzt }}</el-tag
                        >
                      </p>
                      <p>
                        <el-button
                          type="text"
                          @click="getWlInfo(item.lsh, index)"
                          class="fs-16 pb-5 pt-5"
                        >
                          {{ $t("common.chakan") }}[{{ item.lsh }}]{{
                            $t("common.wlxx")
                          }}
                        </el-button>
                      </p>
                    </el-col>
                  </el-row>
                  <!-- 时间线 -->
                  <el-row
                    class="mt-30 ml-50"
                    v-if="activeindex == index"
                    v-loading="loading"
                  >
                    <el-timeline>
                      <el-timeline-item
                        v-for="(activity, i) in activities"
                        :key="i"
                        :icon="activity.icon"
                        :type="activity.type"
                        :color="activity.color"
                        :size="activity.size"
                        :hide-timestamp="true"
                      >
                        <p
                          class="pl-10 pt-5 fs-18"
                          :class="[i == 0 ? 'color-danger' : '']"
                        >
                          <span class="pl-10"
                            >{{ $t("common.date") }}：{{ activity.clsj }}</span
                          >
                          <span class="pl-10"
                            >{{ $t("sqsq.system") }}：{{ activity.xtdm }}</span
                          >
                          <span class="pl-10"
                            >{{ $t("xmsq.zy") }}：{{ activity.bz }}</span
                          >
                          <span class="pl-10"
                            >{{ $t("common.clr") }}：{{ activity.clr }}</span
                          >
                          <span class="pl-10"
                            >{{ $t("common.state") }}：{{ activity.clzt }}</span
                          >
                        </p>
                      </el-timeline-item>
                    </el-timeline>
                  </el-row>
                </el-row>
              </template>
            </div>
            <div
              v-else
              class="pt-30 fs-20 color-7g text-a-c"
              v-loading="loading1"
            >
              <p>{{ $t("common.zwsj") }}</p>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as wldj from "@/api/wldj";
import Languageqh from "@/components/Languageqh.vue";

export default {
  name: "wldjgz",
  components: {
    Languageqh,
  },
  computed: {
    headerStyle() {
      return {
        color: "#606266",
        "background-color": "#e4e7ed",
        border: "1px solid #c0c4cc",
      };
    },
    wldjStyle() {
      return {
        height: this.$store.state.screenHeight - 160 + "px",
      };
    },
    wlsjStyle() {
      return {
        height: this.$store.state.screenHeight - 160 - 193 + "px",
      };
    },
    radioName() {
      switch (this.day) {
        case -7:
          return this.$t("common.jyz") + " " + this.$t("common.data");
          break;
        case -30:
          return this.$t("common.jyy") + " " + this.$t("common.data");
          break;
        case -90:
          return this.$t("common.jsy") + " " + this.$t("common.data");
          break;
        case -365:
          return this.$t("common.jyn") + " " + this.$t("common.data");
          break;
        case -0:
          return this.$t("common.all") + " " + this.$t("common.data");
          break;
      }
    },
  },
  data() {
    return {
      wldjData: [],
      activities: [],
      day: -7,
      lsh: "",
      activeindex: -1,
      loading: false,
      loading1: false,
    };
  },
  methods: {
    getWlList() {
      this.loading1 = true;
      let param = {};
      param.day = this.day;
      if (this.lsh && this.lsh !== "") {
        param.lsh = this.lsh;
        param.day = 0;
      }
      wldj.getLogisticsLsh(param).then((res) => {
        this.wldjData = res.data.data;
        this.loading1 = false;
      });
    },
    clear() {
      this.day = -7;
      this.lsh = "";
      this.getWlList();
    },
    getWlInfo(lsh, index) {
      if (this.activeindex == index) {
        this.activeindex = -1;
      } else {
        this.activeindex = index;
        let param = {};
        param.lsh = lsh;
        this.loading = true;
        wldj.getLogistics(param).then((res) => {
          this.loading = false;
          this.activities = res.data.data;
          this.activities.map((item) => {
            item.type = "success";
            item.icon = "el-icon-circle-check";
            item.size = "20";
          });
          this.activities[0].size = "max";
          this.activities[0].type = "warning";
          this.activities[0].icon = "el-icon-video-play";
        });
      }
    },
  },
  mounted() {
    this.lsh = this.$route.query.lsh;
    this.getWlList();
  },
};
</script>

<style lang="scss"></style>
